const chains = {
  1: {
    ROBONOMICS: {
      ens: "",
      ensSuffix: "eth",
      lighthouse: "airalab.lighthouse.5.robonomics.eth",
    },
    TOKEN: {
      rub: {
        address: "0x2a9688d4FfD94FE6C4447f60B7b25BE0a1ab87b4",
        decimals: 2,
        label: "RUB",
      },
    },
    DEFAULT_LIGHTHOUSE: "airalab",
  },
};

let currentChain;
function set(id) {
  currentChain = id;
}
function get() {
  if (currentChain) {
    return chains[currentChain];
  }
  throw new Error("Chain not selected");
}
function getListId() {
  return Object.keys(chains);
}
export default {
  set,
  get,
  getListId,
};
